// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"nn-z","badgeLink":"on-z","category":"pn-z"};